import AutoAwesomeRoundedIcon from "@mui/icons-material/AutoAwesomeRounded";
import Menu from "./Menu";

const MenuAccordian = (props) => {
  return (
    <section className="preset-library">
      <div className="preset-library-header">
        <span className="preset-library-badge">
          <AutoAwesomeRoundedIcon />
        </span>
        <div>
          <h2>Sample presets</h2>
          <p>Pick a ready-made routine and add it to your task list.</p>
        </div>
      </div>

      <Menu
        setTaskName={props.setTaskName}
        setIsMenuOn={props.setIsMenuOn}
        addTasksToList={props.addTasksToList}
      />
    </section>
  );
};

export default MenuAccordian;
